import styled from 'styled-components';
import CrossIconSvg from './cross-icon.svg';

const CrossIcon = styled(CrossIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '48px'};
  height: ${props => props.height || '48px'};
  fill: ${props => props.fill || '#fff'};
  cursor: pointer;
`;

export default CrossIcon;
